module.exports = __webpack_public_path__ + "img/link_4.2679c53f.png";